import { render, staticRenderFns } from "./proceso.vue?vue&type=template&id=efcb6752"
import script from "./proceso.vue?vue&type=script&lang=js"
export * from "./proceso.vue?vue&type=script&lang=js"
import style0 from "./proceso.vue?vue&type=style&index=0&id=efcb6752&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports